import './App.css';
import React from 'react';
import {DBGLogoNoCreative} from './DBGLogo';

export const DBGLoadingSpinner = () => (
    <div className="DBGSpinnerContainer">
        <DBGLogoNoCreative/>
    </div>
);



